import React, { Fragment, useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-toastify/dist/ReactToastify.css";
import { sanitizeImageUrl } from "../../utils/multiuseFunctions";

const UserTransactions = ({ myData, myClass }) => {
  const [data, setData] = useState();
  useEffect(() => {
    setData(myData || []); // Ensure `data` is always an array
  }, [myData]);

  const hasProductImages =
    Array.isArray(data) && data.some((row) => row?.sellItemDetail?.image);
  const hasBuyImages =
    Array.isArray(data) && data.some((row) => row?.buyItemDetail?.image);

  const columnDefs = [
    {
      name: "S.No",
      selector: (row, index) => index + 1, 
      sortable: true,
    },
    ...(hasProductImages
      ? [
          {
            name: "Product Name",
            selector: (row) => row?.sellItemDetail?.name, 
            sortable: true,
          },
          {
            name: "Product Image",
            cell: (row) =>
              row?.sellItemDetail?.image ? (
                <ProfileImage row={row.sellItemDetail} />
              ) : null,
          },
        ]
      : []),

    ...(hasBuyImages
      ? [
          {
            name: "Product Name",
            selector: (row) => row?.buyItemDetail?.name,
            sortable: true,
          },
          {
            name: "Product Image",
            cell: (row) =>
              row?.buyItemDetail?.image ? (
                <ProfileImage row={row.buyItemDetail} />
              ) : null,
          },
        ]
      : []),
    {
      name: "Amount",
      selector: (row) => row?.amount?.toFixed(2),
      sortable: true,
    },

    {
      name: "Transaction Type",
      selector: (row) => row?.description,
      sortable: true,
    },
    {
      name: "Payment_Method",
      selector: (row) => row?.paymentType,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      sortable: true,
    },

    {
      name: "Date",
      selector: (row) => row?.createdAt,
      sortable: true,
    },
  ];

  return (
    <div>
      <Fragment>
        <DataTableExtensions
          columns={columnDefs}
          data={data}
          print={false}
          export={false}>
          <DataTable
            data={data}
            columns={columnDefs}
            className={myClass}
            pagination
            striped={true}
            center={true}
          />
        </DataTableExtensions>
      </Fragment>
    </div>
  );
};
const ProfileImage = ({ row }) => {
  return (
    <div className="profile-image">
      <img
        src={
          row.image.startsWith("http")
            ? sanitizeImageUrl(row.image)
            : `https://steamcommunity.com/economy/image/${row.image}`
        }
        alt="logo"
      />
    </div>
  );
};

export default UserTransactions;
